import { Outlet } from "react-router-dom";

export default function ArchitectureLayout() {
  return (
    <div style={{ height: "100%", minHeight: "0" }}>
      <Outlet />
    </div>
  );
}
